/* import __COLOCATED_TEMPLATE__ from './user-summary-section.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  classNames: ["top-sub-section"],
});
